import { z } from 'zod/v4';
import {
  ENTITY_SCREENING_ENTITY_TYPE,
  type EntityScreeningEntityType,
} from '../../constants.js';

const entityTypeValues = Object.values(ENTITY_SCREENING_ENTITY_TYPE) as [
  EntityScreeningEntityType,
  ...EntityScreeningEntityType[],
];

export const MatchResultSchema = z.object({
  id: z.string(),
  companyId: z.string(),
  entityId: z.string(),
  entityType: z.enum(entityTypeValues),
  stringSimilarityPercentage: z.number(),
  vectorSimilarityPercentage: z.number(),
  entityEmbeddingId: z.string(),
  isCountryMatched: z.boolean(),
  matchedAt: z.date(),
});

export type MatchResult = z.infer<typeof MatchResultSchema>;
